import React, { FC } from 'react';
import { Flex } from '@mantine/core';
import { useStyles } from './styles';
import { IRowData } from '@components/simple-table/types';
import { EmailActivationControl } from '@components/email-activation/emailActivationControl';
import { EllipsisTooltip } from '@components/EllipsisTooltip';

interface IItemEmailProps {
  item?: IRowData;
}

export const ItemEmail: FC<IItemEmailProps> = ({ item }) => {
  const { classes } = useStyles();

  if (!item?.Email || !item?.Id) {
    return null;
  }

  return (
    <Flex className={classes.container}>
      {!item?.IsConfirmed && item?.Email && (
        <EmailActivationControl Email={item?.Email} Id={item?.Id} customerId={item?.Customer?.Id} />
      )}
      <EllipsisTooltip width={200}>{item?.Email}</EllipsisTooltip>
    </Flex>
  );
};
